// @ts-nocheck

import { request } from '../../context';
import type { ApiOptions } from '../../context';
import type { GetFeishuDepsByDepIdParam, BaseResponseFeishuDepFoundResponse } from '../../types';

/**
 * 获取飞书单个部门信息
 *
 * @export
 * @tags feishu-dep-controller
 * @link [GET] /feishuDeps/{depId}
 * @param depId
 */
export function getFeishuDepsByDepId(
    options: ApiOptions<GetFeishuDepsByDepIdParam, never> & { segments: GetFeishuDepsByDepIdParam }
): Promise<BaseResponseFeishuDepFoundResponse> {
    return request<never, GetFeishuDepsByDepIdParam, never>('/feishuDeps/{depId}', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getFeishuDepsByDepId',
    });
}

export const meta = [
    { tags: ['feishu-dep-controller'], path: '/feishuDeps/{depId}', method: 'get' },
];
